module.exports = __webpack_public_path__ + "static/img/interpretive-illustration05.9291089.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/illustration/interpretive-illustration05.jpg
// module id = 1016
// module chunks = 0